import { CheckoutState } from '../state';

export const getGooglePayInstance = (state: CheckoutState) =>
    state.googlePay.googlePayInstance;

export const getGooglePayPaymentRequest = (state: CheckoutState) =>
    state.googlePay.googlePayPaymentRequest;

export const getCanMakePaymentsWithGooglePay = (state: CheckoutState) =>
    !!state.googlePay.canMakePaymentsWithGooglePay;

export const hasErrorInGooglePay = (state: CheckoutState) =>
    state.googlePay.hasError;
